document.addEventListener("DOMContentLoaded", () => {
  
  const productCards = document.querySelectorAll(".product-card");
  
  productCards.forEach((card) => {
    let lastSelectedSizeTitle = null;

    const swatches = card.querySelectorAll(".custom-color-swatch");
    const deskContainer = card.querySelector(".swatches-desk");
    const mobileContainer = card.querySelector(".options-mobile");
    const addBtns = card.querySelectorAll(".customCart");

    let selectedVariantId = null;

    /* ATC Update Helper */
    const updateATC = (available) => {
      addBtns.forEach((btn) => {
        btn.disabled = !available;
        btn.classList.toggle("disabled", !available);
        btn.innerText = available ? "Add to Cart" : "Sold Out";
      });
    };

    /* Render Desktop Size Buttons */
    const renderDeskButtons = (variants) => {
      deskContainer.innerHTML = "";

      variants.forEach((variant) => {
        const btn = document.createElement("button");
        btn.className = "size-btn";
        btn.innerText = variant.title;
        btn.dataset.variantId = variant.id;

        btn.addEventListener("click", () => {
          deskContainer.querySelectorAll(".size-btn").forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");

          selectedVariantId = variant.id;
          lastSelectedSizeTitle = variant.title;
          updateATC(variant.available);
        });

        deskContainer.appendChild(btn);
      });

      /* ⭐ DEFAULT AUTO-SELECT */
      let autoSelect =
        variants.find(v => v.title === lastSelectedSizeTitle) ||
        variants.find(v => v.title.toLowerCase() === "s") ||
        variants[0];

      const autoBtn = deskContainer.querySelector(`[data-variant-id="${autoSelect.id}"]`);
      if (autoBtn) autoBtn.classList.add("active");

      selectedVariantId = autoSelect.id;
      lastSelectedSizeTitle = autoSelect.title;
      updateATC(autoSelect.available);
    };

    /* Render Mobile Select */
    const renderMobileSelect = (variants) => {
      mobileContainer.innerHTML = "";
      const select = document.createElement("select");
      select.className = "size-select";

      variants.forEach((variant) => {
        const opt = document.createElement("option");
        opt.value = variant.id;
        opt.textContent = variant.title;
        select.appendChild(opt);
      });

      mobileContainer.appendChild(select);

      let autoSelect =
        variants.find(v => v.title === lastSelectedSizeTitle) ||
        variants.find(v => v.title.toLowerCase() === "s") ||
        variants[0];

      select.value = autoSelect.id;
      selectedVariantId = autoSelect.id;
      lastSelectedSizeTitle = autoSelect.title;
      updateATC(autoSelect.available);

      select.addEventListener("change", () => {
        const v = variants.find(vv => vv.id == select.value);
        selectedVariantId = v.id;
        lastSelectedSizeTitle = v.title;
        updateATC(v.available);
      });
    };

    /* Render both desktop & mobile ONLY if multiple sizes */
    const renderVariants = (variants) => {
      if (variants.length > 1) {
        renderDeskButtons(variants);
        renderMobileSelect(variants);
      } else {
        deskContainer.innerHTML = "";
        mobileContainer.innerHTML = "";

        const single = variants[0];
        selectedVariantId = single.id;
        lastSelectedSizeTitle = single.title;
        updateATC(single.available);
      }
    };

    /* Load Product */
    const loadProduct = (handle) => {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => renderVariants(product.variants))
        .catch(console.error);
    };

    /* Default Swatch */
   /* Default Swatch + Strong Fallback using product-card handle */
    let activeLabel = card.querySelector("label.active .custom-color-swatch");
    let productHandleFallback = card.getAttribute("handle"); // NEW fallback

    if (activeLabel && activeLabel.dataset.handle) {
      // Correct default swatch
      activeLabel.classList.add("active");
      loadProduct(activeLabel.dataset.handle);

    } else if (swatches.length > 0 && swatches[0].dataset.handle) {

      const first = swatches[0];
      first.classList.add("active");
      loadProduct(first.dataset.handle);

    } else if (productHandleFallback) {

      console.warn("⚠ No swatch found → loading product from card handle:", productHandleFallback);
      loadProduct(productHandleFallback);

    } else {
      console.error("❌ No swatch and no product handle found. Cannot load variants.");
    }


    /* Swatch change */
    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        swatches.forEach(s => s.classList.remove("active"));
        swatch.classList.add("active");
        loadProduct(swatch.dataset.handle);
      });
    });

    /* Add to Cart */
    addBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!selectedVariantId) return;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
        })
          .then(r => r.json())
          .then(cart => console.log("Added to cart:", cart))
          .catch(console.error);
      });
    });

  }); // END productCards Loop

});



